import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Row,
  Col,
  Select,
  DatePicker,
  Input,
  message,
  Popconfirm,
  Button,
  SuccessNotification,
} from "components/common";
import { callGetApiWithAuth, callPutApiWithAuth } from "utils/api";
import { countryStates } from "common/country";
// import Google2FAModal from "components/common/modals/Google2FAModal";

export default function TygaBankOptionCard({
  isActive,
  provider,
  loadListData,
}) {
  const myUser = useSelector((state) => state.auth.user);
  const sudoName = useSelector((state) => state.auth.sudo_name);
  const [formData, setFormData] = useState({
    email: "",
    first_name: "",
    last_name: "",
  });
  // const [faModal, setFaModal] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  const onFormInput = (field, value) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const onSaveDone = () => {
    setIsUpdating(false);
    SuccessNotification("TygaBank has been set as your payout provider.");
    loadListData();
  };

  const handleSave = () => {
    // check validation
    if (!formData.first_name || !formData.last_name || !formData.email) {
      message.error("Input all required fields");
      return;
    }

    setIsUpdating(true);
    const body = sudoName
      ? {
        form_info: {
          ...formData,
          sudo_name: sudoName,
          // code: code,
        },
      }
      : {
        form_info: formData,
        // code
      };
    callPutApiWithAuth(
      `my_account/payment_option/${provider.id}/activate`,
      body,
      onSaveDone,
      () => setIsUpdating(false)
    );
  };

  const goTyga = (res) => {
    window.open(res.data.loginUrl, "_blank")
  }

  const handleClickTyga = () => {
    callGetApiWithAuth(
      `my_account/payment_option/tyga_sso_url`,
      goTyga,
      () => setIsUpdating(false)
    );
  }

  useEffect(() => {
    if (provider?.form_info) {
      setFormData({
        email: provider.form_info.email,
        first_name: provider.form_info.first_name,
        last_name: provider.form_info.last_name,
      });
    } else {
      setFormData({
        email: myUser.email,
        first_name: myUser.first_name,
        last_name: myUser.last_name,
      });
    }
  }, [provider, myUser]);

  return (
    <div className="payment-card-section">
      <div className="payment-title">
        <span>TygaBank</span>
        {isActive && <span className="active-badge">ACTIVE</span>}
      </div>
      <div className="payment-form-text" style={{ margin: "10px 0px 0px" }}>
        Powered by TygaBank
      </div>
      <div className="payment-description" style={{ marginTop: "5px" }}>
        NUEVA offers its members a new fast, secure and cost effective payment
        method.
      </div>
      {/* <div className="payment-description" style={{ margin: "5px 0px 20px" }}>
        Your Global eWallet account has been successfully registered.
      </div> */}
      <div className="payment-form" style={{ marginTop: "10px" }}>
        <Row gutter={[12, 8]}>
          <Col xs={24} md={12} lg={8}>
            <div className="form-group">
              <Input
                label="First Name*"
                value={formData.first_name}
                onChange={(e) => onFormInput("first_name", e.target.value)}
                disabled={provider.account}
              />
            </div>
          </Col>
          <Col xs={24} md={12} lg={8}>
            <div className="form-group">
              <Input
                label="Last Name*"
                value={formData.last_name}
                onChange={(e) => onFormInput("last_name", e.target.value)}
                disabled={provider.account}
              />
            </div>
          </Col>
          <Col xs={24} md={12} lg={8}>
            <div className="form-group">
              <Input
                value={formData.email}
                label="Email*"
                onChange={(e) => onFormInput("email", e.target.value)}
                disabled={provider.account}
              />
            </div>
          </Col>
        </Row>
        <div className="action-group">
          {!isActive && (
            <Popconfirm onConfirm={handleSave}>
              <Button loading={isUpdating}>
                {provider.account ? `Activate` : `Create & Activate`}
              </Button>
            </Popconfirm>
          )}
          <Button onClick={handleClickTyga}>Go to Tyga Account</Button>
        </div>
      </div>
      {/* <Google2FAModal visible={faModal} onCancel={() => setFaModal(false)} onSubmit={handleSave} isLoading={isUpdating}/> */}
    </div>
  );
}
